import api from './../api'
import { locales } from './../lang'
import wizard from './../wizard'
import {
  healthRecord,
  healthRecordModels,
  healthRecordAddModel,
  hrGroups,
} from './health-record/index'

const constants = Object.freeze({
  api,
  locales,
  wizard,
  healthRecord,
  healthRecordModels,
  healthRecordAddModel,
  hrGroups,
})

export { constants }
export default constants
